import api from "../helpers/axios";

class ChatCategoryService {
    async getAllCategories() {
        try {
            const response = await api.get("/admin/chat-categories");
            return response.data;
        } catch (error) {
            console.error("Error fetching chat categories:", error);
            throw error;
        }
    }

    async createCategory(payload) {
        try {
            const response = await api.post("/admin/chat-categories", payload);
            return response.data;
        } catch (error) {
            console.error("Error creating chat category:", error);
            throw error;
        }
    }

    async updateCategory(categoryId, payload) {
        try {
            const response = await api.put(`/admin/chat-categories/${categoryId}`, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating chat category:", error);
            throw error;
        }
    }
}

export default new ChatCategoryService();
